export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 5-Minute Start Guide',
    short: 'The 5-Minute Start Guide',
    body: 'Five minutes to know where to start, about an hour to be ready for your first class. Pick your room — students, club, adults or ESL — and get your week-one session, three backups and what to leave for later, plus a first-class checklist and a start card to print.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/fA4Psr9i5o46nDdoQsfULN/DPS41_-_Bono_1_-_The_5-Minute_Start_Guide.png',
  },
  {
    number: '02',
    title: 'The Master Session Finder',
    short: 'Master Session Finder',
    body: 'One lookup tool across all six volumes. Pick today’s session in 30 seconds — by goal, by room (students, club, adults or ESL) or by the minutes you have — with the volume and page for all 134 sessions.',
    accent: 'bg-teal',
    cover: 'https://cdn.magicpatterns.com/uploads/uTHpmss2VCi1Hh4P6Pyb7E/DPS41_-_Bono_2_-_The_Master_Session_Finder.png',
  },
  {
    number: '03',
    title: 'The Facilitator Cheat-Sheet',
    short: 'Facilitator Cheat-Sheet',
    body: 'Run any session smoothly: read a page in 60 seconds, keep the clock with simple signals, say the exact transition lines between parts, know what to cut when time runs short — and get a silent room talking again, step by step.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/sRbc9XuzdEG7knztiL3dCy/DPS41_-_Bono_3_-_The_Facilitator_Cheat-Sheet.png',
  },
  {
    number: '04',
    title: 'Tricky-Room Rescue Cards',
    short: 'Tricky-Room Rescue Cards',
    body: 'Eight rescue cards with the exact words and moves for the people who knock a session sideways: the over-talker, the silent one, the speaker who freezes, the class clown, mixed levels, the dead online room, the harsh critic and the reluctant adult.',
    accent: 'bg-indigo',
    cover: 'https://cdn.magicpatterns.com/uploads/3NjZxEUzTXNyDzcSaT58GC/DPS41_-_Bono_4_-_Tricky-Room_Rescue_Cards.png',
  },
  {
    number: '05',
    title: 'The Online & Hybrid Quick-Guide',
    short: 'Online & Hybrid Quick-Guide',
    body: 'Move any session to video or a mixed room in four margin notes: turn-taking that stops people talking over each other, breakout rooms, camera and eye-line, a minimum tech checklist and six tweaks by session type.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/x6cU6fRSfUDUShCn2Esvbf/DPS41_-_Bono_5_-_The_Online__Hybrid_Quick-Guide.png',
  },
]
